import api from './api';

const dashboardService = {
  /**
   * Get dashboard statistics
   * @returns {Promise<object>}
   */
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error?.message || 'Failed to fetch dashboard stats');
  },
};

export default dashboardService;
